
import wikiTextScroll from '~/components/common/wikiTextScroll.vue'
export default {
  components: { 'wiki-text-scroll': wikiTextScroll },
  props: {
    isbt: {
      // 是否显示加入和认领按钮
      type: Boolean,
      default: true
    },
    isclass: {
      // 类名设置
      type: Boolean,
      default: false
    },
    type: {
      // 类型，2-交易商；1-服务商
      type: Number,
      default: 2
    },
    result: {
      // 数据
      type: Object,
      default: () => {}
    },
    addtradertype: {
      // 0加入还是1认领
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectshow: false,
      labelmore: false,
      value1: 2,
      colors: ['#FFD733', '#FFD733', '#FFD733'],
      iconClasses: ['iconfont icon-Frame-3', 'iconfont icon-Frame-3', 'iconfont icon-Frame-3']
    }
  },
  mounted() {
    this.setele()
  },
  methods: {
    setele() {
      // 计算labei下拉
      const ele = document.getElementById('trader-list-add')
      if (ele && ele.clientHeight > 25) this.selectshow = true
    },
    handleImageError(event) {
      event.target.src = 'https://resources1.interface003.com/web20/img/default/103_60.png'
    }
  }
}
